export const LABEL_CONFIG_DEPENDENT_TYPES = {
  ORDERS: "orders",
};

export const LABEL_CONFIG_AREAS = {
  CARD: "card",
  HOVER_CARD: "hover-card",
};
